"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var PlayerState_1 = __importStar(require("../constants/PlayerState"));

var getAriaLabelForVideoPlayer_1 = __importDefault(require("../utils/getAriaLabelForVideoPlayer"));

var loadOrPlayOrPause_1 = __importDefault(require("../utils/loadOrPlayOrPause"));

var PlayerError_1 = __importDefault(require("../utils/PlayerError"));

var withTheme_1 = require("../utils/withTheme");

var PlayIcon_1 = __importDefault(require("./icons/PlayIcon"));

var PauseIcon_1 = __importDefault(require("./icons/PauseIcon"));

var handleClick = function handleClick(e, controller, playerState, streamInfo, throwError, setPlayQueued) {
  try {
    e.preventDefault();
    loadOrPlayOrPause_1["default"](controller, playerState, streamInfo, {
      autoPlay: true
    }, setPlayQueued);
  } catch (err) {
    throwError(new PlayerError_1["default"](err.message, {
      fatal: true,
      innerError: err
    }));
  }
};

var handleMouseDown = function handleMouseDown(e) {
  // Prevent focus on mouse down
  e.preventDefault();
};

var getAriaLabel = function getAriaLabel(playerState, streamInfo, duration) {
  switch (playerState) {
    case PlayerState_1["default"].STOPPED:
    case PlayerState_1["default"].LOADING:
    case PlayerState_1["default"].LOADED:
    case PlayerState_1["default"].ENDED:
      return getAriaLabelForVideoPlayer_1["default"](streamInfo, duration);

    case PlayerState_1["default"].PAUSED:
      return 'Spela';

    case PlayerState_1["default"].BUFFERING:
    case PlayerState_1["default"].PLAYING:
    case PlayerState_1["default"].SEEKING:
      return 'Pausa';
  }
};

var PlayPauseButton = function PlayPauseButton(_a, _b) {
  var _c;

  var controller = _a.controller,
      playerState = _a.playerState,
      streamInfo = _a.streamInfo,
      centered = _a.centered,
      loaderVisible = _a.loaderVisible,
      duration = _a.duration,
      setPlayQueued = _a.setPlayQueued,
      className = _a.className,
      innerRef = _a.innerRef;
  var theme = _b.theme,
      throwError = _b.throwError;
  var extraClassName = className ? (_c = {}, _c[className] = true, _c) : {};
  return withTheme_1.withTheme(theme, __assign({
    'play-pause-button': true,
    'play-pause-button--paused': PlayerState_1.isPaused(playerState),
    'play-pause-button--centered': Boolean(centered),
    'play-pause-button--is-hidden': Boolean(loaderVisible && centered)
  }, extraClassName))(React.createElement("button", {
    onClick: function onClick(e) {
      return controller && handleClick(e, controller, playerState, streamInfo, throwError, setPlayQueued);
    },
    onMouseDown: handleMouseDown,
    onTouchEnd: function onTouchEnd(e) {
      return controller && handleClick(e, controller, playerState, streamInfo, throwError, setPlayQueued);
    },
    "aria-label": getAriaLabel(playerState, streamInfo, duration || (streamInfo ? streamInfo.duration : 0)),
    ref: innerRef
  }, PlayerState_1.isPaused(playerState) ? React.createElement(PlayIcon_1["default"], null) : React.createElement(PauseIcon_1["default"], null)));
};

PlayPauseButton.contextTypes = {
  theme: PropTypes.object,
  throwError: PropTypes.func
};
exports["default"] = PlayPauseButton;